import * as e from "react";
const o = typeof window < "u" ? e.useLayoutEffect : e.useEffect;
export {
  o as useIsomorphicLayoutEffect
};
//# sourceMappingURL=use-isomorphic-layout-effect.es.mjs.map
